import { AppData } from "../../AppDataProvider";
import { ChangeSelectedTimezonePayload } from "../../actions";
import { Mixpanel } from "../../../mixpanel/mixpanel";

export type ChangeSelectedTimezoneOpts = {
  appData: AppData;
  payload: ChangeSelectedTimezonePayload;
};

export const changeSelectedTimezone = (
  options: ChangeSelectedTimezoneOpts,
): AppData => {
  const { bookingData } = options.appData;
  const { timezone } = options.payload.updatedData;

  Mixpanel.track({
    name: "Changed timezone",
    props: { from: bookingData.timezone, to: timezone },
  });

  const updatedBookingData = {
    ...bookingData,
    timezone,
  };

  return {
    ...options.appData,
    bookingData: updatedBookingData,
  };
};
